import acls from '@Ravnur-Inc/shared/helpers/acls';
import { PortalSettings } from '@Ravnur-Inc/shared/types/PortalSettings';

const usePortalSettings = (): PortalSettings | Record<string, undefined> => {
  return acls.getApplicationSettings?.() ?? {};
};

export default usePortalSettings;
